<template>
  <v-container>
    <v-form ref="form" v-model="validado">
      <v-row dense>
         <!-- Botón de regreso -->
        <v-col cols="12">
          <v-btn icon class="mb-3" @click="$router.go(-1)">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
        </v-col>
        <v-col cols="12" class="pb-3">
          <div class="text-h5">Mi Finca</div>
        </v-col>
        <v-col cols="12">
          <div class="font-weight-medium blue-grey--text">
            Los campos con * son requeridos
          </div>
        </v-col>
        <br />
        <br />

        <!--          <v-col cols="3">
          <form-meta
            :data="finca"
            :remove-commit="'removerFinca'"
            :record-id="finca.id"
            @removed="$router.go(-1)"
          />
        </v-col> -->
        <!--  <v-col cols="12">
          <v-text-field
            v-model="finca.id_productor"
            :rules="[r.required, r.max(23)]"
            label="Cédula o Pasaporte*"
            append-icon="mdi-account"
            outlined
            @input="debounceBuscarRegistroExistente"
          />
        </v-col> -->
        <v-col cols="12">
          <div class="text-h5 font-weight-bold">
            Información General de la Finca:
          </div>
        </v-col>
        <v-col cols="12">
          <v-text-field
            v-model="finca.nombre"
            :disabled="!!existing_finca.nombre"
            :rules="[r.required, r.max()]"
            label="Nombre de la finca*"
            outlined
            @input="debounceObtenerFincasPorNombre"
          />
        </v-col>
        <v-col cols="12">
          <v-text-field
            v-model.number="finca.extension"
            :rules="[r.required, r.float, r.min_num(0), r.max_num()]"
            label="Extensión (superficie) Total en la Finca*"
            suffix="Ha"
            outlined
          >
          </v-text-field>
        </v-col>
        <!--  <v-col cols="12">
          <div class="text-h6">Inventario de finca</div>
        </v-col> -->

        <v-col cols="12">
          <div class="text-h5 font-weight-bold">Ubicación de la finca:</div>
        </v-col>
        <v-col cols="6">
          <v-select
            v-model="finca.id_provincia"
            :rules="[r.required]"
            :items="provincia"
            item-text="NOMBRE_PROVINCIA"
            item-value="ID_PROVINCIA"
            label="Provincia*"
            outlined
            @input="limpiarDistrito"
          >
          </v-select>
        </v-col>
        <v-col cols="6">
          <v-select
            v-model="finca.id_distrito"
            :rules="[r.required]"
            :items="distritos(finca.id_provincia)"
            item-text="NOMBRE_DISTRITO"
            item-value="ID_DISTRITO"
            label="Distrito*"
            outlined
            @input="limpiarCorregimiento"
          >
          </v-select>
        </v-col>
        <v-col cols="6">
          <v-select
            v-model="finca.id_corregimiento"
            :rules="[r.required]"
            :items="corregimientos(finca.id_distrito)"
            item-text="NOMBRE_CORREGIMIENTO"
            item-value="ID_CORREGIMIENTO"
            label="Corregimiento*"
            outlined
            @input="limpiarPoblado"
          >
          </v-select>
        </v-col>
        <v-col cols="6">
          <v-select
            v-model="finca.id_poblado"
            :rules="[r.required]"
            :items="poblados(finca.id_corregimiento)"
            item-text="NOMBRE_POBLADO"
            item-value="ID_POBLADO"
            label="Poblado*"
            outlined
          >
          </v-select>
        </v-col>
        <v-col cols="12">
          <div class="text-h7 font-weight-bold">Mi Mapa</div>
        </v-col>
        <v-col cols="12" v-show="obtenerPosicionVar">
          <v-col cols="12">
            <v-btn
              depressed
              block
              class="primary--text"
              @click="obtenerPosicion"
            >
              <v-icon left>mdi-crosshairs</v-icon>
              Registrar coordenadas (párese en cada una de las esquinas de la
              finca y presion el botón.)
            </v-btn>
          </v-col>

          <v-row>
            <v-col cols="6">
              <v-textarea
                v-model="coordenadasString"
                :rules="[validateLatLong, validarPoligonoCierra]"
                label="Latitud/Longitud"
                placeholder="Ej: 40.7128 -74.0060"
                outlined
                @input="validarCoordenadas"
              >
              </v-textarea>
            </v-col>
            <v-col cols="6">
              <v-btn
                block
                depressed
                class="primary--text"
                @click="finalizarUbicacion"
              >
                <v-icon left>mdi-check-circle</v-icon>
                Cerrar Área
                <v-spacer></v-spacer>
                <v-icon
                  color="blue"
                  class="white--text"
                  @click.stop="mostrarMensaje"
                >
                  mdi-help-circle
                </v-icon>
              </v-btn>
            </v-col>
            <!-- <v-col cols="6">
              <v-textarea
                v-model="utmString"
                label="UTM"
                placeholder="Ej: 33T 500000 4649776"
                outlined
                @input="updateLatLonFromUTM"
              >
              </v-textarea>
            </v-col> -->
          </v-row>
          <!-- <v-btn depressed block class="primary--text" @click="mostrarMapa">
            <v-icon left>mdi-crosshairs</v-icon>
            Ver mi Mapa
          </v-btn> -->
          <v-col cols="12">
            <div ref="mapContainer" style="height: 300px"></div>
          </v-col>
        </v-col>
        <v-col v-if="name_exists" cols="12">
          <div
            class="text-body-2 warning--text"
            v-text="
              'El Nombre de esta finca ya ha sido registrado, coloque otro o uno parecido.'
            "
          />
        </v-col>
        <v-col cols="11">
          <v-text-field
            v-model="finca.ruc"
            :rules="[r.max(23)]"
            label="RUC de la empresa, si quiero relacionar mi finca con mi empresa"
            outlined
            @input="debounceBuscarRegistroExistenteRuc"
          />
        </v-col>
        <v-col cols="11">
          <v-text-field
            v-model="finca.num_registro"
            label="Mi Número de Registro Público"
            outlined
            :rules="[r.int, r.max(), r.min_num(1)]"
            @input="debounceObtenerFincasPorRegistro"
          />
        </v-col>
        <v-col cols="12">
          <div class="text-h6 font-weight-bold">
            <h3>
              Datos para aplicar a programas de beneficio y ayudar a mejorar los Servicios que nos brindan las
              instituciones: Carretera, Pozos, Programa de Titulación de Tierra,
              etc.
            </h3>
          </div>
        </v-col>
        <v-col cols="12">
          <v-text-field
            v-model.number="finca.distancia_vivienda"
            :rules="[r.required, r.float, r.min_num(0), r.max_num()]"
            label="Distancia entre la finca y la vivienda del productor*"
            suffix="km"
            outlined
          >
          </v-text-field>
        </v-col>
        <v-col cols="9">
          <v-select
            v-model="finca.administrada_por"
            :rules="[r.required]"
            :items="tipo_administracion"
            item-text="descripcion"
            item-value="id"
            label="¿Administración de mi Finca?*"
            outlined
          >
          </v-select>
        </v-col>
        <v-col cols="12">
          <div class="text-h5 font-weight-bold">
            Características físicas y recursos hídricos:
          </div>
          <div class="text-h6 font-weight-bold">
            Características del terreno
          </div>
        </v-col>

        <!-- <v-col cols="12">
          <v-select
            v-model="finca.id_agencia"
            :rules="[r.required]"
            :items="agencia"
            item-text="descripcion"
            item-value="id"
            label="Agencia que atiende la finca de este productor*"
            outlined
          >
          </v-select>
        </v-col> -->
        <v-col cols="12">
          <div class="text-h6 font-weight-bold">Tipo de terreno</div>
        </v-col>
        <!-- listado dinámico de terrenos -->
        <v-col cols="12">
          <v-btn depressed block class="primary--text" @click="agregarTerreno">
            <v-icon left>mdi-plus</v-icon>
            Agregar tipo de terreno
          </v-btn>
        </v-col>
        <template v-for="(tenencia, index) in finca.terrenos">
          <v-col :key="`${index}terreno`" cols="5">
            <v-select
              v-model="tenencia.tipo_terreno"
              :rules="[r.required]"
              :items="tipo_terreno_filtrado"
              label="Tipo de terreno*"
              outlined
            >
              <template v-slot:selection="props">
                <div v-text="props.item[props.parent.$props.itemText]" />
              </template>
            </v-select>
          </v-col>
          <v-col :key="`${index}extension_terreno`" cols="7">
            <v-text-field
              v-model.number="tenencia.extension"
              :error="finca.extension != total_terreno"
              :rules="[r.required, r.float]"
              label="Extensión (superficie)*"
              suffix="Ha"
              outlined
            >
              <v-icon
                slot="append-outer"
                :disabled="!puedeRemoverTerreno"
                class="error--text"
                @click="removerTerreno(index)"
              >
                mdi-close
              </v-icon>
            </v-text-field>
          </v-col>
        </template>
        <v-col cols="12">
          <div class="text-h6 font-weight-bold">Tenencia</div>
        </v-col>
        <!-- listado dinámico de tenencias -->
        <v-col cols="12">
          <v-btn depressed block class="primary--text" @click="agregarTenencia">
            <v-icon left>mdi-plus</v-icon>
            Agregar tenencia
          </v-btn>
        </v-col>
        <template v-for="(tenencia, index) in finca.tenencias">
          <v-col :key="`${index}tenencia`" cols="5">
            <v-select
              v-model="tenencia.tenencia_tierra"
              :rules="[r.required]"
              :items="tenencia_filtrada"
              label="Tipo de tenencia*"
              outlined
            >
              <template v-slot:selection="props">
                <div v-text="props.item[props.parent.$props.itemText]" />
              </template>
            </v-select>
          </v-col>
          <v-col :key="`${index}extension`" cols="7">
            <v-text-field
              v-model.number="tenencia.extension"
              :error="touched[index] && finca.extension !== total_tenencia"
              :error-messages="
                touched[index] && finca.extension !== total_tenencia
                  ? 'El total de la superficie bajo tenencia no coincide con el total de la finca.'
                  : ''
              "
              :rules="[r.required, r.float]"
              label="Extensión bajo tenencia*"
              suffix="Ha"
              outlined
              @input="touched[index] = true"
            >
              <v-icon
                slot="append-outer"
                :disabled="!puedeRemoverTenencia"
                class="error--text"
                @click="removerTenencia(index)"
              >
                mdi-close
              </v-icon>
            </v-text-field>
          </v-col>
        </template>
        <v-col cols="12">
          <div class="text-h6 font-weight-bold">Fuentes de agua:</div>
        </v-col>
        <v-col cols="12"> Fuentes de Agua existentes: </v-col>
        <v-col cols="6">
          <v-select
            v-model="finca.fuente_agua"
            multiple
            :items="fuente_agua"
            item-text="descripcion"
            item-value="id"
            label="Fuente de agua"
            outlined
          >
          </v-select>
        </v-col>
        <v-col cols="12">
          <div class="text-h5 font-weight-bold">
            Infraestructura productiva y mis necesidades:
          </div>
        </v-col>

        <!-- <v-col cols="6">
          <v-select
            v-model="finca.entidad_apoyo"
            multiple
            :items="institucion"
            item-text="descripcion"
            item-value="id"
            label="¿De cuál institución u Organización recibe apoyo en esta finca?"
            outlined
          >
          </v-select>
        </v-col> -->
        <!--     <v-col cols="12">
          Necesidades de mantenimiento o Creación de infraestructuras
          Productivas. Actualmente tengo:
        </v-col> -->
        <v-col cols="12">
          <v-select
            v-model="finca.accesibilidad"
            :rules="[r.required]"
            :items="accesibilidad"
            item-text="descripcion"
            item-value="id"
            label="Facilidades de acceso (en vehículo u otros)*"
            outlined
          >
          </v-select>
        </v-col>
        <!--  <v-col cols="6">
          <v-text-field
            v-model.number="finca.tiempo_acceso_verano"
            :rules="[r.float, r.min_num(0.1), r.max_num(48)]"
            persistent-hint
            hint="Desde la regional más cercana del MIDA"
            label="Tiempo de acceso en verano"
            suffix="hora(s)"
            outlined
          >
          </v-text-field>
        </v-col>
        <v-col cols="6">
          <v-text-field
            v-model.number="finca.tiempo_acceso_invierno"
            :rules="[r.float, r.min_num(0.1), r.max_num(48)]"
            persistent-hint
            hint="Desde la regional más cercana del MIDA"
            label="Tiempo de acceso en invierno"
            suffix="hora(s)"
            outlined
          >
          </v-text-field>
        </v-col> -->
        <!-- <v-col cols="12">
          Solicitud o planificación de Almacenamiento, actualmente tengo:
        </v-col> -->
        <v-col cols="12">
          <v-select
            v-model="finca.infraestructura_almacenamiento"
            :items="sino"
            item-text="descripcion"
            item-value="id"
            label="¿Infraestructura de almacenamiento en la Finca?"
            outlined
          >
          </v-select>
        </v-col>
        <v-col cols="12">
          <div class="text-h5 font-weight-bold">
            Bienes asegurados y/o financiados y solicitudes de apoyo:
          </div>
        </v-col>
        <v-col cols="12">
          <div class="text-h7">
            Mis bienes asegurados y/o producción asegurada contra desastres y/o
            la necesidad de solicitar apoyo
          </div>
        </v-col>
        <v-col v-show="bien_asegurado_repetido" cols="12">
          <n-text error :fix-required="bien_asegurado_repetido">
            Se colocaron valores duplicados para bienes y tipos de
            aseguramientos.
          </n-text>
        </v-col>
        <!-- listado dinámico de aseguramientos -->
        <v-col cols="12">
          <v-btn
            depressed
            block
            class="primary--text"
            @click="agregarAseguramiento"
          >
            <v-icon left>mdi-plus</v-icon>
            Agregar bien asegurado
          </v-btn>
        </v-col>
        <template v-for="(aseguramiento, index) in finca.aseguramientos">
          <v-col :key="`${index}bien_asegurado`" cols="5">
            <v-select
              v-model="aseguramiento.activo"
              :rules="[r.required]"
              :items="activo"
              label="Bien asegurado"
              outlined
            >
            </v-select>
          </v-col>
          <v-col :key="`${index}tipo_aseguramiento`" cols="7">
            <v-select
              v-model="aseguramiento.tipo_entidad_aseguradora"
              :rules="[r.required]"
              :items="tipo_entidad_aseguradora"
              label="Tipo de seguro"
              outlined
            >
              <v-icon
                slot="append-outer"
                :disabled="!puedeRemoverAseguramiento"
                class="error--text"
                @click="removerAseguramiento(index)"
              >
                mdi-close
              </v-icon>
            </v-select>
          </v-col>
        </template>
        <v-col cols="12">
          <div class="text-h7">
            Financiamiento de mis bienes y/o producción y/o la necesidad de
            solicitar apoyo
          </div>
        </v-col>
        <v-col v-show="bien_financiado_repetido" cols="12">
          <n-text error :fix-required="bien_financiado_repetido">
            Se colocaron valores duplicados para bienes y tipos de
            financiamientos.
          </n-text>
        </v-col>
        <!-- listado dinámico de financiamientos -->
        <v-col cols="12">
          <v-btn
            depressed
            block
            class="primary--text"
            @click="agregarFinanciamiento"
          >
            <v-icon left>mdi-plus</v-icon>
            Agregar bien financiado
          </v-btn>
        </v-col>
        <template v-for="(financiamiento, index) in finca.financiamientos">
          <v-col :key="`${index}bien_financiamiento`" cols="5">
            <v-select
              v-model="financiamiento.activo"
              :rules="[r.required]"
              :items="activo"
              label="Tipo de Bien"
              outlined
            >
            </v-select>
          </v-col>
          <v-col :key="`${index}tipo_financiamiento`" cols="7">
            <v-select
              v-model="financiamiento.tipo_entidad_financiera"
              :rules="[r.required]"
              :items="tipo_entidad_financiera"
              label="Tipo de financiamiento"
              outlined
            >
              <v-icon
                slot="append-outer"
                :disabled="!puedeRemoverFinanciamiento"
                class="error--text"
                @click="removerFinanciamiento(index)"
              >
                mdi-close
              </v-icon>
            </v-select>
          </v-col>
        </template>
        <v-col cols="12">
          <div class="text-h5 font-weight-bold">
            Asistencias Técnicas (Cuenta o necesita asistencia técnica?)
          </div>
        </v-col>
        <!-- <v-col cols="12">
          Planificación y Solicitud de Asistencia Técnica, Mejoras a Fincas y apoyos, Actualmente tengo:
        </v-col> -->
        <v-col cols="6">
          <v-select
            v-model="finca.asistencias"
            multiple
            :items="tipo_asistencia"
            label="Asistencias técnicas"
            outlined
          >
          </v-select>
        </v-col>
        <v-col cols="6">
          <v-select
            v-model="finca.actividades"
            multiple
            :items="actividad"
            label="Actividades"
            outlined
          >
          </v-select>
        </v-col>
        <!-- Fila de espaciado -->
        <v-col cols="12" class="py-5"></v-col>

        <!-- <v-col cols="12">
          Fuentes de Agua existentes: apoyos de mantenimiento y creación de Nuevas Fuentes de Agua o Potable. Actualmente tengo: 
        </v-col>
        <v-col cols="6">
          <v-select
            v-model="finca.fuente_agua"
            multiple
            :items="fuente_agua"
            item-text="descripcion"
            item-value="id"
            label="Fuente de agua"
            outlined
          >
          </v-select>
        </v-col> -->
        <!-- <v-col cols="12">
          Planificación y Solicitud de Asistencia Técnica, Mejoras a Fincas y apoyos, Actualmente tengo:
        </v-col>
        <v-col cols="6">
          <v-select
            v-model="finca.asistencias"
            multiple
            :items="tipo_asistencia"
            label="Asistencias técnicas"
            outlined
          >
          </v-select>
        </v-col>
        <v-col cols="6">
          <v-select
            v-model="finca.actividades"
            multiple
            :items="actividad"
            label="Actividades"
            outlined
          >
          </v-select>
        </v-col>  -->
        <!-- <v-col cols="12">
          Planificación o Solicitud de Almacenamiento , Actualmente tengo:
        </v-col>
        <v-col cols="6">
          <v-select
            v-model="finca.infraestructura_almacenamiento"
            :items="sino"
            item-text="descripcion"
            item-value="id"
            label="¿La finca cuenta con infraestructura de almacenamiento?"
            outlined
          >
          </v-select>
        </v-col> -->
        <!-- <v-col cols="12">
          <v-select
            v-model="finca.administrada_por"
            :rules="[r.required]"
            :items="tipo_administracion"
            item-text="descripcion"
            item-value="id"
            label="¿Administrada por?*"
            outlined
          >
          </v-select>
        </v-col> -->
        <!--Boton de coordenadas actuales-->
        <!-- <v-col cols="12" class="d-flex justify-center">
          <v-btn cols="6" class="mr-4">
            <div class="text-h6" block depressed @click="apagarCargaGpx">
              Obtener Posicion Actual
            </div>
          </v-btn> -->

        <!-- Boton de cargar archivo GPX
          <v-btn cols="6" class="ml-4">
            <div class="text-h6" block depressed @click="apagarPosicionActual">
              Cargar Archivo (GPX)
            </div>
          </v-btn>
        </v-col>  -->

        <!--Componente de coordenadas actuales-->
        <!-- <v-col cols="12" v-show="obtenerPosicionVar">
          <v-col cols="12">
            <div class="text-h6">Ver mi Finca en mi Mapa</div>
          </v-col>
          <v-col cols="12">
            <v-btn
              depressed
              block
              class="primary--text"
              @click="obtenerPosicion"
            >
              <v-icon left>mdi-crosshairs</v-icon>
              Botón para ubicación de la finca en mi Mapa
            </v-btn>
          </v-col>

          <v-row>
            <v-col cols="6">
              <v-textarea
                v-model="coordenadasString"
                :rules="[validateLatLong, validarPoligonoCierra]"
                label="Latitud/Longitud"
                placeholder="Ej: 40.7128 -74.0060"
                outlined
                @input="validarCoordenadas"
              >
              </v-textarea>
            </v-col>
            
            <v-col cols="6">
              <v-btn 
              depressed 
              block
              class="primary--text"
              @click="finalizarUbicacion"
              >
              <v-icon left>mdi-check-circle</v-icon>
              Finalizar Ubicación
            </v-btn>
            </v-col> -->
        <!-- <v-col cols="6">
              <v-textarea
                v-model="utmString"
                label="UTM"
                placeholder="Ej: 33T 500000 4649776"
                outlined
                @input="updateLatLonFromUTM"
              >
              </v-textarea>
            </v-col> -->
        <!-- </v-row>
          <v-btn depressed block class="primary--text" @click="mostrarMapa">
            <v-icon left>mdi-crosshairs</v-icon>
            Ver mi Mapa
          </v-btn>
          <v-col v-show="mapVisible" cols="12">
            <div id="mapita"></div>
          </v-col>
        </v-col> -->

        <!--Componente de subir archivo GPX-->
        <!--         <v-container class="py-0" v-show="cargarArchivoVar">
          <v-col cols="12">
            <div class="text-h6">Subir archivo (GPX)</div>
          </v-col>
          <v-row class="pt-4">
            <v-col cols="12" class="d-flex align-center">
              <v-file-input
                v-model="archivo"
                outlined
                label="Subir archivo gpx"
                @change="cambio"
                accept=".GPX"
              />
            </v-col>
          </v-row>
        </v-container> -->
        <v-col cols="12" class="py-5"></v-col>

        <!-- <v-col cols="12">
          <v-text-field
            v-model.number="finca.distancia_vivienda"
            :rules="[r.required, r.float, r.min_num(0), r.max_num()]"
            label="Distancia de la finca a la vivienda del productor*, para calcular mis posibles Beneficios de agricultura familiar"
            suffix="km"
            outlined
          >
          </v-text-field>
        </v-col> -->

        <!-- <v-col cols="12">
          <div class="text-h6">Tipo de terreno</div>
        </v-col> -->
        <!-- listado dinámico de terrenos -->
        <!-- <v-col cols="12">
          <v-btn depressed block class="primary--text" @click="agregarTerreno">
            <v-icon left>mdi-plus</v-icon>
            Agregar tipo de terreno
          </v-btn>
        </v-col>
        <template v-for="(tenencia, index) in finca.terrenos">
          <v-col :key="`${index}terreno`" cols="5">
            <v-select
              v-model="tenencia.tipo_terreno"
              :rules="[r.required]"
              :items="tipo_terreno_filtrado"
              label="Tipo de terreno*"
              outlined
            >
              <template v-slot:selection="props">
                <div v-text="props.item[props.parent.$props.itemText]" />
              </template>
            </v-select>
          </v-col>
          <v-col :key="`${index}extension_terreno`" cols="7">
            <v-text-field
              v-model.number="tenencia.extension"
              :error="finca.extension != total_terreno"
              :rules="[r.required, r.float]"
              label="Extensión (superficie)*"
              suffix="Ha"
              outlined
            >
              <v-icon
                slot="append-outer"
                :disabled="!puedeRemoverTerreno"
                class="error--text"
                @click="removerTerreno(index)"
              >
                mdi-close
              </v-icon>
            </v-text-field>
          </v-col>
        </template> -->
        <!--   <v-col cols="12">
          <div class="font-weight-medium grey--text text--darken-2">
            {{ `Total de superficie: ${finca.extension} Ha` }}
          </div>
          <div class="font-weight-medium grey--text text--darken-2">
            {{ `Superficie por terreno: ${total_terreno} Ha` }}
          </div>
          <div
            v-show="finca.extension != total_terreno"
            class="font-weight-medium error--text"
          >
            La suma de los terrenos debe igualar la superficie de la finca.
          </div>
        </v-col> -->
        <!-- <v-col cols="12">
          <div class="text-h6">Tenencia (Apoyo en Programas de Titulación de Tierra)</div>
        </v-col> -->
        <!-- listado dinámico de tenencias -->
        <!-- <v-col cols="12">
          <v-btn depressed block class="primary--text" @click="agregarTenencia">
            <v-icon left>mdi-plus</v-icon>
            Agregar tenencia
          </v-btn>
        </v-col>
        <template v-for="(tenencia, index) in finca.tenencias">
          <v-col :key="`${index}tenencia`" cols="5">
            <v-select
              v-model="tenencia.tenencia_tierra"
              :rules="[r.required]"
              :items="tenencia_filtrada"
              label="Tenencia*"
              outlined
            >
              <template v-slot:selection="props">
                <div v-text="props.item[props.parent.$props.itemText]" />
              </template>
            </v-select>
          </v-col>
          <v-col :key="`${index}extension`" cols="7">
            <v-text-field
              v-model.number="tenencia.extension"
              :error="finca.extension != total_tenencia"
              :rules="[r.required, r.float]"
              label="Extensión (superficie)*"
              suffix="Ha"
              outlined
            >
              <v-icon
                slot="append-outer"
                :disabled="!puedeRemoverTenencia"
                class="error--text"
                @click="removerTenencia(index)"
              >
                mdi-close
              </v-icon>
            </v-text-field>
          </v-col>
        </template> -->
        <!-- <v-col cols="12">
          <div class="font-weight-medium grey--text text--darken-2">
            {{ `Total de superficie: ${finca.extension} Ha` }}
          </div>
          <div class="font-weight-medium grey--text text--darken-2">
            {{ `Superficie por tenencia: ${total_tenencia} Ha` }}
          </div>
          <div
            v-show="finca.extension != total_tenencia"
            class="font-weight-medium error--text"
          >
            La suma de las tenencias debe igualar la superficie de la finca.
          </div>
        </v-col> -->
        <!-- <v-col cols="12">
          <div class="text-h6">Mis bienes asegurados y/o producción asegurada contra desastres y/o la necesidad de solicitar apoyo</div>
        </v-col>
        <v-col v-show="bien_asegurado_repetido" cols="12">
          <n-text error :fix-required="bien_asegurado_repetido">
            Se colocaron valores duplicados para bienes y tipos de aseguramientos.
          </n-text>
        </v-col> -->
        <!-- listado dinámico de aseguramientos -->
        <!-- <v-col cols="12">
          <v-btn
            depressed
            block
            class="primary--text"
            @click="agregarAseguramiento"
          >
            <v-icon left>mdi-plus</v-icon>
            Agregar bien asegurado
          </v-btn>
        </v-col>
        <template v-for="(aseguramiento, index) in finca.aseguramientos">
          <v-col :key="`${index}bien_asegurado`" cols="5">
            <v-select
              v-model="aseguramiento.activo"
              :rules="[r.required]"
              :items="activo"
              label="Tipo de Bien"
              outlined
            >
            </v-select>
          </v-col>
          <v-col :key="`${index}tipo_aseguramiento`" cols="7">
            <v-select
              v-model="aseguramiento.tipo_entidad_aseguradora"
              :rules="[r.required]"
              :items="tipo_entidad_aseguradora"
              label="Tipo de aseguramiento"
              outlined
            >
              <v-icon
                slot="append-outer"
                :disabled="!puedeRemoverAseguramiento"
                class="error--text"
                @click="removerAseguramiento(index)"
              >
                mdi-close
              </v-icon>
            </v-select>
          </v-col>
        </template> -->
        <!-- <v-col cols="12">
          <div class="text-h6">Financiamiento: mi producción para nuevos proyectos de crecimiento o Solicitar Apoyo. Actualmente tengo:</div>
        </v-col>
        <v-col v-show="bien_financiado_repetido" cols="12">
          <n-text error :fix-required="bien_financiado_repetido">
            Se colocaron valores duplicados para bienes y tipos de
            financiamientos.
          </n-text>
        </v-col> -->
        <!-- listado dinámico de financiamientos -->
        <!-- <v-col cols="12">
          <v-btn
            depressed
            block
            class="primary--text"
            @click="agregarFinanciamiento"
          >
            <v-icon left>mdi-plus</v-icon>
            Agregar bien financiado
          </v-btn>
        </v-col>
        <template v-for="(financiamiento, index) in finca.financiamientos">
          <v-col :key="`${index}bien_financiamiento`" cols="5">
            <v-select
              v-model="financiamiento.activo"
              :rules="[r.required]"
              :items="activo"
              label="Tipo de Bien"
              outlined
            >
            </v-select>
          </v-col>
          <v-col :key="`${index}tipo_financiamiento`" cols="7">
            <v-select
              v-model="financiamiento.tipo_entidad_financiera"
              :rules="[r.required]"
              :items="tipo_entidad_financiera"
              label="Tipo de financiamiento"
              outlined
            >
              <v-icon
                slot="append-outer"
                :disabled="!puedeRemoverFinanciamiento"
                class="error--text"
                @click="removerFinanciamiento(index)"
              >
                mdi-close
              </v-icon>
            </v-select>
          </v-col>
        </template> -->
        <!--   <v-col cols="12">
          <div class="text-h6">Mis Tareas Pendientes</div>
        </v-col>
        <v-col cols="12">
          <v-textarea
            v-model="finca.observacion"
            :rules="[r.max(1000)]"
            label="Anotaciones o Tareas pendientes"
            auto-grow
            outlined
            rows="1"
          >
          </v-textarea>
        </v-col> -->
        <v-col class="btn-final" cols="12">
          <v-btn class="cancel" @click="Cancelar"> Cancelar </v-btn>
          <save-btn
            class="btn-oval"
            :record-id="finca.id"
            :record-status="finca.estatus"
            :loading="loading"
            @click="guardarYContinuar"
          />
        </v-col>
      </v-row>
    </v-form>
    <registro-existente
      :title="'La finca ya existe'"
      :description="'Los datos colocados corresponden a una finca existente, desea cargar la información de esta finca?'"
      :loading="modal_registro_existe_loading"
      :modal="modal_registro_existe"
      @cerrarModal="cerrarModalRegistroExistente"
      @cargarDatos="cargarRegistroExistente"
    />
    <registro-noexistente
      :title="'Esta Empresa No Existe'"
      :description="'El RUC colocado NO corresponde a una Empresa existente, verifique la información.'"
      :modal="modal_registro_existe_Ruc"
      :loading="modal_registro_existe_loading"
      @cerrarModal="cerrarModalDeRegistroExistenteRuc"
    />
  </v-container>
</template>

<script>
import uuid from 'uuid/v4'
import * as turf from '@turf/turf'
import 'leaflet/dist/leaflet.css'
import L from 'leaflet'
import { Icon } from 'leaflet'
import debounce from 'lodash.debounce'
import { mapState, mapGetters } from 'vuex'
import {
  getCurrentPosition,
  clona,
  elObjetoTienePropiedades,
} from '../../utilidades'
import {
  formulario_de_finca,
  tenencia_finca,
  finca_aseguramiento,
  finca_financiamiento,
  terreno_finca,
  formulario_empresa,
} from '../../modelos'
import * as rules from '@/utils/validations'

delete Icon.Default.prototype._getIconUrl
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
})

const existing_empresa = {
  ruc: '',
}
const existing_finca = {
  num_registro: '',
  nombre: '',
  id_productor: '',
}

export default {
  name: 'Finca',
  data: () => {
    return {
      latlongGPX: '',
      obtenerPosicionVar: true,
      cargarArchivoVar: false,
      touched: {},
      archivo: null,
      coordenadaslatlongpx: [],
      poligonoCerrado: false,
      r: rules,
      validado: false,
      modal_registro_existe: false,
      modal_registro_existe_loading: false,
      modal_registro_existe_Ruc: false,
      registro_existente: {},
      existing_empresa: clona(existing_empresa),
      finca: clona(formulario_de_finca),
      existing_finca: clona(existing_finca),
      name_exists: false,
      loading: false,
      empresa: clona(formulario_empresa),
      ruc: '',
      coordenadas: [],
      coordenadasString: '',
      utmString: '',
      mapVisible: false,
      ubicacionFinalizada: false,
      map: null,
    }
  },
  computed: {
    // retorna cierto si existe al menos un terreno en el arreglo de terrenos de la finca
    puedeRemoverTerreno() {
      return this.finca.terrenos.length >= 2
    },
    // retorna cierto si existe al menos una tenencia en el arreglo de tenencias de la finca
    puedeRemoverTenencia() {
      return this.finca.tenencias.length >= 2
    },
    // retorna cierto si existe al menos un aseguramiento en el arreglo de aseguramientos de la finca
    puedeRemoverAseguramiento() {
      return this.finca.aseguramientos.length >= 1
    },
    // retorna cierto si existe al menos un financiamiento en el arreglo de financiamientos de la finca
    puedeRemoverFinanciamiento() {
      return this.finca.financiamientos.length >= 1
    },
    total_tenencia() {
      if (this.finca.tenencias.length > 1) {
        const total = this.finca.tenencias.reduce(
          (acum, curr) => acum + curr.extension,
          0
        )
        return typeof total === 'number' && !isNaN(total) ? total.toFixed(2) : 0
      } else if (this.finca.tenencias.length === 1) {
        return this.finca.tenencias[0].extension
      } else {
        return 0
      }
    },
    total_terreno() {
      if (this.finca.terrenos.length > 1) {
        const total = this.finca.terrenos.reduce(
          (acum, curr) => acum + curr.extension,
          0
        )
        return typeof total === 'number' && !isNaN(total) ? total.toFixed(2) : 0
      } else if (this.finca.terrenos.length === 1) {
        return this.finca.terrenos[0].extension
      } else {
        return 0
      }
    },
    puedeGuardar() {
      const id = this.finca
        ? this.finca.id
          ? this.finca.id.toString()
          : ''
        : ''
      return this.obtenerIdDeRuta() === '' || this.obtenerIdDeRuta() === id
    },
    ...mapState('listados', [
      'provincia',
      'distrito',
      'corregimiento',
      'poblado',
      'agencia',
      'institucion',
      'fuente_agua',
      'accesibilidad',
      'tipo_asistencia',
      'sistema_produccion',
      'sino',
      'tipo_administracion',
      'tipo_terreno',
      'tenencia_tierra',
      'activo',
      'tipo_entidad_financiera',
      'tipo_entidad_aseguradora',
      'actividad',
    ]),
    ...mapGetters('listados', [
      'distritos',
      'corregimientos',
      'poblados',
      'getSino',
    ]),
    ...mapGetters('registros', [
      'existeRegistroEnState',
      'registroConPropiedades',
      'getMatchingRecords',
    ]),
    ...mapState('registros', ['productor']),
    tenencia_filtrada() {
      const selected = this.finca.tenencias.map((v) => v.tenencia_tierra)
      return this.tenencia_tierra.map((v) => ({
        text: v,
        disabled: selected.includes(v),
      }))
    },
    tipo_terreno_filtrado() {
      const selected = this.finca.terrenos.map((v) => v.tipo_terreno)
      return this.tipo_terreno.map((v) => ({
        text: v,
        disabled: selected.includes(v),
      }))
    },
    bien_asegurado_repetido() {
      let rep = 0
      const cant_aseg = this.finca.aseguramientos.length
      for (const aseg of this.finca.aseguramientos) {
        for (const aseg2 of this.finca.aseguramientos) {
          if (
            aseg.activo === aseg2.activo &&
            aseg.tipo_entidad_aseguradora === aseg2.tipo_entidad_aseguradora
          ) {
            rep++
          }
        }
      }
      return rep > cant_aseg
    },
    bien_financiado_repetido() {
      let rep = 0
      const cant_finan = this.finca.financiamientos.length
      for (const aseg of this.finca.financiamientos) {
        for (const aseg2 of this.finca.financiamientos) {
          if (
            aseg.activo === aseg2.activo &&
            aseg.tipo_entidad_financiera === aseg2.tipo_entidad_financiera
          ) {
            rep++
          }
        }
      }
      return rep > cant_finan
    },
  },
  watch: {
    '$route.params.id'() {
      this.cargarRegistro(this.obtenerIdDeRuta())
    },
    utmString(newVal) {
      if (!newVal) {
        this.coordenadasString = '' // Si UTM se borra, borra latlong
      }
    },
    coordenadasString(newVal) {
      if (!newVal) {
        this.utmString = '' // Si latlong se borra, borra UTM
      }
    },
  },
  mounted() {
    this.$store.commit('ui/updateToolbar', 'Finca')
    const id = this.obtenerIdDeRuta()
    if (id) {
      this.cargarRegistro(id)
    } else {
      this.finca = clona(formulario_de_finca)
      this.finca.id_productor = this.productor.id
    }
    this.$nextTick(() => {
      this.inicializarMapa()
      // this.map = L.map('mapita', { attributionControl: false }).setView(
      //   [8.8434471, -79.7883048],
      //   8
      // )
      // L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      //   maxZoom: 19,
      // }).addTo(this.map)
    })
  },
  methods: {
    mostrarMensaje() {
      this.$store.commit('ui/setSnack', {
        color: 'info',
        text: "Camine punto por punto hasta los límites de su lote o parcela y use el botón 'Registrar ubicación actual' para marcar cada punto. Las coordenadas aparecerán en el campo de abajo. Al regresar al punto de inicio, presione 'Cerrar área' para finalizar el proceso.",
        timeout: 8000,
      })
    },
    apagarPosicionActual() {
      this.obtenerPosicionVar = false
      this.cargarArchivoVar = true
    },
    apagarCargaGpx() {
      this.cargarArchivoVar = false
      this.obtenerPosicionVar = true
    },
    cambio(event) {
      this.leerArchivo(event)
    },
    inicializarMapa() {
      // Asegurar que el div existe antes de crear el mapa
      this.$nextTick(() => {
        // Si ya existe un mapa, eliminarlo antes de crear uno nuevo
        if (this.map) {
          this.map.remove()
          this.map = null
        }
        const mapaDiv = this.$refs.mapContainer

        if (!mapaDiv) {
          console.warn('El contenedor del mapa no está disponible aún.')
          return
        }

        this.map = L.map(mapaDiv, { attributionControl: false }).setView(
          [8.8434471, -79.7883048],
          8
        )

        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
          maxZoom: 19,
        }).addTo(this.map)
        // Esperar a que el mapa termine de inicializarse antes de validar coordenadas
        this.map.whenReady(() => {
          if (this.coordenadasString.trim() !== '') {
            this.validarCoordenadas()
          }
        })
      })
    },
    Cancelar() {
      this.$router.push('/ru/fincas')
    },
    leerArchivo(event) {
      console.log('Leyendo archivo')
      const archivo = event
      const reader = new FileReader()

      console.log('ANTES DE reador.onload')
      reader.onload = () => {
        console.log('DESPUE DE reador.onload')
        const parser = new DOMParser()
        const xmlDoc = parser.parseFromString(reader.result, 'text/xml')

        // Extraer coordenadas de los puntos trkpt
        const trkpts = xmlDoc.getElementsByTagName('trkpt')
        this.coordenadaslatlongpx = Array.from(trkpts).map((point) => ({
          lat: point.getAttribute('lat'),
          lon: point.getAttribute('lon'),
        }))

        // Verificar si el polígono está cerrado, si esta cerrado es true y si no es false
        this.poligonoCerrado = this.esPoligonoCerrado()

        // Si no está cerrado, cerrar el polígono
        if (!this.poligonoCerrado) {
          console.log('El polígono no esta cerrado')
          console.log(
            this.coordenadaslatlongpx[0].lat,
            this.coordenadaslatlongpx[0].lon
          )
          console.log(
            this.coordenadaslatlongpx[this.coordenadaslatlongpx.length - 1].lat,
            this.coordenadaslatlongpx[this.coordenadaslatlongpx.length - 1].lon
          )

          this.cerrarPoligono()
          console.log('El polígono se ha cerrado.')
          console.log(
            this.coordenadaslatlongpx[0].lat,
            this.coordenadaslatlongpx[0].lon
          )
          console.log(
            this.coordenadaslatlongpx[this.coordenadaslatlongpx.length - 1].lat,
            this.coordenadaslatlongpx[this.coordenadaslatlongpx.length - 1].lon
          )

          console.log(
            'leerArchivo this.coordenadaslatlonggpx',
            this.coordenadaslatlongpx
          )
        } else {
          console.log('El polígono esta cerrado')
        }
        this.guardarGPX()
      }
      reader.readAsText(archivo)

      console.log('Termino de leer el archivo')
    },

    esPoligonoCerrado() {
      // Verificar si el primer y último punto son iguales
      const primerPunto = this.coordenadaslatlongpx[0]
      const ultimoPunto =
        this.coordenadaslatlongpx[this.coordenadaslatlongpx.length - 1]
      return (
        primerPunto.lat === ultimoPunto.lat &&
        primerPunto.lon === ultimoPunto.lon
      )
    },

    cerrarPoligono() {
      // Agregar el primer punto al final del arreglo de coordenadas
      const primerPunto = this.coordenadaslatlongpx[0]
      this.coordenadaslatlongpx.push(primerPunto)
    },

    async guardarGPX() {
      // Crear la cadena WKT para lat/lon
      const wktlatlon = `POLYGON((${this.coordenadaslatlongpx
        .map((coord) => `${coord.lon} ${coord.lat}`)
        .join(', ')}))`

      this.latlongGPX = wktlatlon
      /* console.log('wktlatlon', wktlatlon);
      console.log('this.coordenadaslatlongpx', this.coordenadaslatlongpx); */
      console.log('this.latlongGPX', this.latlongGPX)

      // Convertir las coordenadas lat/lon a UTM
      const coordenadasUTM = await Promise.all(
        this.coordenadaslatlongpx.map((coord) => {
          return this.latLonToUTM(coord.lat, coord.lon)
        })
      )

      // Combinar todos los resultados en una sola cadena separada por comas
      const cadenaUTM = coordenadasUTM.join(', ')
      console.log('cadenaUTM:', cadenaUTM)

      this.utmString = cadenaUTM
    },

    limpiarDistrito() {
      this.finca.id_distrito = ''
      this.finca.id_corregimiento = ''
      this.finca.id_poblado = ''
    },
    limpiarCorregimiento() {
      this.finca.id_corregimiento = ''
      this.finca.id_poblado = ''
    },
    limpiarPoblado() {
      this.finca.id_poblado = ''
    },
    async obtenerPosicion() {
      const position = await getCurrentPosition()
      if (position) {
        //this.coordenadasString = `${position.coords.latitude} ${position.coords.longitude}`;
        const nuevaCoordenadaString = `${position.coords.latitude} ${position.coords.longitude}`
        this.coordenadasString += nuevaCoordenadaString
          ? ` ${nuevaCoordenadaString}`
          : nuevaCoordenadaString
        this.coordenadas.push([
          position.coords.latitude,
          position.coords.longitude,
        ])
        await this.validarCoordenadas()
      }
    },
    async finalizarUbicacion() {
      await this.validarCoordenadas()
      const validacionPoligono = this.validarPoligonoCierra(
        this.coordenadasString
      )

      if (this.validado && validacionPoligono == true) {
        this.ubicacionFinalizada = true
        this.$store.commit('ui/setSnack', {
          text: 'Ubicación finalizada',
          color: 'success',
        })
      } else {
        this.$store.commit('ui/setSnack', {
          text:
            validacionPoligono !== true
              ? validacionPoligono
              : 'Error en la validación de coordenadas',
          color: 'error',
        })
      }
    },
    addMarker(lat, lon) {
      if (this.marker) {
        this.map.removeLayer(this.marker)
      }
      this.marker = L.marker([lat, lon]).addTo(this.map)
      this.map.setView([lat, lon], 8)
    },
    addPolygon(coords) {
      if (this.polygon) {
        this.map.removeLayer(this.polygon)
      }
      this.polygon = L.polygon(coords, {
        color: 'blue',
        fillColor: '#3e64ff',
        fillOpacity: 0.5,
      }).addTo(this.map)
      this.map.fitBounds(this.polygon.getBounds())
    },

    mostrarMapa() {
      this.validarCoordenadas()
      this.mapVisible = !this.mapVisible
      this.$nextTick(() => {
        if (this.mapVisible) {
          this.map.invalidateSize()
          if (this.coordenadas.length === 1) {
            const { lat, lon } = this.coordenadas[0]
            if (!isNaN(lat) && !isNaN(lon)) {
              this.addMarker(lat, lon)
            }
          }
        }
      })
    },
    // agrega un objeto de terreno al arreglo de terrenos de la finca
    agregarTerreno() {
      this.finca.terrenos.push({ ...terreno_finca })
    },
    // agrega un objeto de tenencia al arreglo de tenencias de la finca
    agregarTenencia() {
      this.finca.tenencias.push({ ...tenencia_finca })
    },
    // remueve un terreno del arreglo de terrenos
    removerTerreno(index) {
      if (this.puedeRemoverTerreno) {
        this.finca.terrenos.splice(index, 1)
      }
    },
    // remueve una tenencia del arreglo de tenencias
    removerTenencia(index) {
      if (this.puedeRemoverTenencia) {
        this.finca.tenencias.splice(index, 1)
      }
    },
    // agrega un objeto de aseguramiento al arreglo de aseguramientos de la finca
    agregarAseguramiento() {
      this.finca.aseguramientos.push({ ...finca_aseguramiento })
    },
    // remueve un aseguramiento del arreglo de aseguramientos
    removerAseguramiento(index) {
      if (this.puedeRemoverAseguramiento) {
        this.finca.aseguramientos.splice(index, 1)
      }
    },
    // agrega un objeto de financiamiento al arreglo de financiamientos de la finca
    agregarFinanciamiento() {
      this.finca.financiamientos.push({ ...finca_financiamiento })
    },
    // remueve un financiamiento del arreglo de financiamientos
    removerFinanciamiento(index) {
      if (this.puedeRemoverFinanciamiento) {
        this.finca.financiamientos.splice(index, 1)
      }
    },
    async latLonToUTM(lat, lon) {
      const zone = Math.floor((lon + 180) / 6) + 1
      const a = 6378137.0
      const e = 0.0818191908426
      const k0 = 0.9996

      const lonOrigin = (zone - 1) * 6 - 180 + 3
      const lonOriginRad = lonOrigin * (Math.PI / 180)
      const latRad = lat * (Math.PI / 180)
      const lonRad = lon * (Math.PI / 180)

      const N = a / Math.sqrt(1 - Math.pow(e * Math.sin(latRad), 2))
      const T = Math.pow(Math.tan(latRad), 2)
      const C = ((e * e) / (1 - e * e)) * Math.pow(Math.cos(latRad), 2)
      const A = Math.cos(latRad) * (lonRad - lonOriginRad)

      const M =
        a *
        ((1 -
          (e * e) / 4 -
          (3 * e * e * e * e) / 64 -
          (5 * e * e * e * e * e * e) / 256) *
          latRad -
          ((3 * e * e) / 8 +
            (3 * e * e * e * e) / 32 +
            (45 * e * e * e * e * e * e) / 1024) *
            Math.sin(2 * latRad) +
          ((15 * e * e * e * e) / 256 + (45 * e * e * e * e * e * e) / 1024) *
            Math.sin(4 * latRad) -
          ((35 * e * e * e * e * e * e) / 3072) * Math.sin(6 * latRad))

      const easting =
        k0 *
          N *
          (A +
            ((1 - T + C) * Math.pow(A, 3)) / 6 +
            ((5 - 18 * T + T * T + 72 * C - 58 * e * e) * Math.pow(A, 5)) /
              120) +
        500000
      const northing =
        k0 *
        (M +
          N *
            Math.tan(latRad) *
            ((A * A) / 2 +
              ((5 - T + 9 * C + 4 * C * C) * Math.pow(A, 4)) / 24 +
              ((61 - 58 * T + T * T + 600 * C - 330 * e * e) * Math.pow(A, 6)) /
                720))

      return `${zone} ${Math.round(easting)} ${Math.round(northing)}`
    },

    utmToLatLon({ zoneNumber, easting, northing }) {
      const a = 6378137.0 // WGS84 major axis
      const eccSquared = 0.00669438 // WGS84 eccentricity squared
      const k0 = 0.9996

      const e1 =
        (1 - Math.sqrt(1 - eccSquared)) / (1 + Math.sqrt(1 - eccSquared))
      const x = easting - 500000.0 // Remove 500,000 meter offset for longitude
      let y = northing

      // Set the Northern Hemisphere if zoneLetter >= N
      const northernHemisphere = true // Panama is in the Northern Hemisphere
      if (!northernHemisphere) {
        y -= 10000000.0 // Remove 10,000,000 meter offset used for southern hemisphere
      }

      const longOrigin = (zoneNumber - 1) * 6 - 180 + 3 // +3 puts origin in middle of zone

      const eccPrimeSquared = eccSquared / (1 - eccSquared)

      const M = y / k0
      const mu =
        M /
        (a *
          (1 -
            eccSquared / 4 -
            (3 * eccSquared * eccSquared) / 64 -
            (5 * eccSquared * eccSquared * eccSquared) / 256))

      const phi1Rad =
        mu +
        ((3 * e1) / 2 - (27 * e1 * e1 * e1) / 32) * Math.sin(2 * mu) +
        ((21 * e1 * e1) / 16 - (55 * e1 * e1 * e1 * e1) / 32) *
          Math.sin(4 * mu) +
        ((151 * e1 * e1 * e1) / 96) * Math.sin(6 * mu)

      const N1 =
        a / Math.sqrt(1 - eccSquared * Math.sin(phi1Rad) * Math.sin(phi1Rad))
      const T1 = Math.tan(phi1Rad) * Math.tan(phi1Rad)
      const C1 = eccPrimeSquared * Math.cos(phi1Rad) * Math.cos(phi1Rad)
      const R1 =
        (a * (1 - eccSquared)) /
        Math.pow(1 - eccSquared * Math.sin(phi1Rad) * Math.sin(phi1Rad), 1.5)
      const D = x / (N1 * k0)

      const lat =
        phi1Rad -
        ((N1 * Math.tan(phi1Rad)) / R1) *
          ((D * D) / 2 -
            ((5 + 3 * T1 + 10 * C1 - 4 * C1 * C1 - 9 * eccPrimeSquared) *
              Math.pow(D, 4)) /
              24 +
            ((61 +
              90 * T1 +
              298 * C1 +
              45 * T1 * T1 -
              252 * eccPrimeSquared -
              3 * C1 * C1) *
              Math.pow(D, 6)) /
              720)
      const lon =
        (D -
          ((1 + 2 * T1 + C1) * Math.pow(D, 3)) / 6 +
          ((5 -
            2 * C1 +
            28 * T1 -
            3 * C1 * C1 +
            8 * eccPrimeSquared +
            24 * T1 * T1) *
            Math.pow(D, 5)) /
            120) /
        Math.cos(phi1Rad)
      const longitude = longOrigin + lon * (180 / Math.PI)

      return {
        lat: ((lat * 180) / Math.PI).toPrecision(7),
        lon: longitude.toPrecision(7),
      }
    },
    async validarCoordenadas() {
      await this.updateUTMFromLatLon()
      const coordsArray = this.coordenadasString.trim().split(' ')

      if (coordsArray.length < 2 || coordsArray.length % 2 !== 0) {
        this.validado = false
        return
      }

      this.validado = true
      this.coordenadas = []

      for (let i = 0; i < coordsArray.length; i += 2) {
        const lat = parseFloat(coordsArray[i])
        const lon = parseFloat(coordsArray[i + 1])
        if (!isNaN(lat) && !isNaN(lon)) {
          this.coordenadas.push([lat, lon])
        }
      }

      if (this.coordenadas.length === 1) {
        const [lat, lon] = this.coordenadas[0]
        if (!isNaN(lat) && !isNaN(lon)) {
          this.addMarker(lat, lon)

          // Validar si el punto está dentro del polígono de la provincia
          const fincaSeleccionada = this.finca.id_finca
          if (!fincaSeleccionada) {
            console.log('Finca no encontrada')
            this.validado = false
            return
          }

          const idProvincia = this.finca.id_provincia
          const provinciaCoords = this.getCoordenadasProvincia(idProvincia) // Debe devolver las coordenadas del polígono

          if (provinciaCoords.length < 4) {
            console.error(
              'Las coordenadas de la provincia no son suficientes para formar un polígono'
            )
            this.validado = false
            return
          }

          // Crear un polígono usando Turf.js
          const polygonProvincia = turf.polygon([provinciaCoords])
          const point = turf.point(this.coordenadas[0])
          const isInside = turf.booleanPointInPolygon(point, polygonProvincia)

          if (!isInside) {
            this.$store.commit('ui/setSnack', {
              text: 'El punto está fuera del área de la provincia seleccionada',
              color: 'error',
            })
            this.validado = false
            return
          }
        }
      } else if (this.coordenadas.length > 1) {
        // Asegúrate de que el polígono esté cerrado
        if (
          this.coordenadas[0][0] !==
            this.coordenadas[this.coordenadas.length - 1][0] ||
          this.coordenadas[0][1] !==
            this.coordenadas[this.coordenadas.length - 1][1]
        ) {
          this.coordenadas.push(this.coordenadas[0])
        }

        if (this.coordenadas.length >= 4) {
          this.addPolygon(this.coordenadas)

          // Obtener las coordenadas del polígono de la provincia seleccionada
          const fincaSeleccionada = this.finca.id_finca
          if (!fincaSeleccionada) {
            this.$store.commit('ui/setSnack', {
              text: 'Finca no encontrada',
              color: 'error',
            })
            this.validado = false
            return
          }

          const idProvincia = this.finca.id_provincia
          const provinciaCoords = this.getCoordenadasProvincia(idProvincia) // Debe devolver las coordenadas del polígono

          if (provinciaCoords.length < 3) {
            this.$store.commit('ui/setSnack', {
              text: 'Las coordenadas de la provincia no son suficientes para formar un polígono',
              color: 'error',
            })
            this.validado = false
            return
          }

          // Crear un polígono usando Turf.js
          const polygonProvincia = turf.polygon([provinciaCoords])
          const inputPolygon = turf.polygon([this.coordenadas])
          const isInside = turf.booleanContains(polygonProvincia, inputPolygon)

          if (!isInside) {
            this.$store.commit('ui/setSnack', {
              text: 'Las coordenadas están fuera del área de la provincia seleccionada',
              color: 'error',
            })
            return
          }
        } else {
          this.$store.commit('ui/setSnack', {
            text: 'El polígono del usuario no tiene suficientes puntos para ser válido',
            color: 'error',
          })
          return
        }
      }
    },

    async updateUTMFromLatLon() {
      const coordsArray = this.coordenadasString.trim().split(' ')
      if (coordsArray.length < 2 || coordsArray.length % 2 !== 0) {
        return
      }
      let utmArray = []
      for (let i = 0; i < coordsArray.length; i += 2) {
        const lat = parseFloat(coordsArray[i])
        const lon = parseFloat(coordsArray[i + 1])
        if (!isNaN(lat) && !isNaN(lon)) {
          const utm = await this.latLonToUTM(lat, lon)
          utmArray.push(utm)
        }
      }
      this.utmString = utmArray.join(', ')
    },

    updateLatLonFromUTM() {
      const utmArray = this.utmString.trim().split(/\s+/) // Dividir por uno o más espacios

      const coords = []
      for (let i = 0; i < utmArray.length; i += 3) {
        const zoneNumber = parseInt(utmArray[i])
        const easting = parseFloat(utmArray[i + 1])
        const northing = parseFloat(utmArray[i + 2])
        if (!isNaN(zoneNumber) && !isNaN(easting) && !isNaN(northing)) {
          const coord = this.utmToLatLon({ zoneNumber, easting, northing })
          coords.push(coord)
        }
      }

      this.coordenadas = coords
      this.updateLatLonString()
    },

    convertirCoordenadas() {
      const coordsArray = this.coordenadasString.trim().split(' ')
      if (coordsArray.length < 2 || coordsArray.length % 2 !== 0) {
        this.wktString = 'Formato de coordenadas incorrecto'
        return
      }
      if (coordsArray.length === 2) {
        this.coordenadasString = `POINT(${coordsArray.join(' ')})`
      } else {
        this.coordenadasString = `POLYGON(${coordsArray.join(' ')})`
      }
    },

    validarPoligonoCierra(value) {
      const coordsArray = value.trim().split(' ')
      if (coordsArray.length < 4) {
        return true // No hay suficientes coordenadas para formar un polígono, se omite esta validación
      }

      const firstCoord1 = coordsArray[0]
      const firstCoord2 = coordsArray[1]
      const lastCoord1 = coordsArray[coordsArray.length - 2]
      const lastCoord2 = coordsArray[coordsArray.length - 1]

      if (firstCoord1 !== lastCoord1 || firstCoord2 !== lastCoord2) {
        return 'Las coordenadas del polígono deben cerrar en el mismo punto en el que comenzaron.'
      }

      return true
    },
    // Función para obtener el polígono de la provincia actual
    getCoordenadasProvincia(idprovincia) {
      const provincias = {
        1: [
          [9.085102, -82.932137],
          [9.467305, -82.92115],
          [9.610448, -82.854833],
          [9.567775, -82.561686],
          [9.129493, -81.98543],
          [8.860921, -82.178139],
          [9.144004, -82.323488],
          [8.98999, -82.445972],
          [8.935948, -82.356967],
          [8.823806, -82.370032],
          [8.899529, -82.690262],
          [9.085102, -82.932137],
        ],
        2: [
          [9.05558, -80.196959],
          [8.409205, -80.043613],
          [8.094279, -80.494332],
          [8.179925, -80.739464],
          [8.557881, -80.818787],
          [8.9317, -80.545004],
          [8.859357, -80.366981],
          [9.05558, -80.196959],
        ],
        3: [
          [8.877059, -80.86707],
          [8.63296, -80.738824],
          [8.636075, -80.718964],
          [8.783947, -80.651563],
          [8.789206, -80.556462],
          [8.943778, -80.545892],
          [8.86679, -80.364545],
          [9.063015, -80.196555],
          [8.947819, -80.140548],
          [8.992875, -79.969638],
          [9.198515, -79.918925],
          [9.114065, -79.685648],
          [9.488335, -79.484496],
          [9.34603, -79.252305],
          [9.557815, -79.085346],
          [9.634816, -79.567833],
          [8.877059, -80.86707],
        ],
        4: [
          [8.001949, -81.66458],
          [8.309626, -81.529975],
          [8.46796, -82.078706],
          [8.448576, -82.191392],
          [8.755379, -82.17996],
          [8.918726, -82.713461],
          [8.835139, -82.877049],
          [8.751829, -82.916889],
          [8.488054, -82.829921],
          [8.333183, -83.049647],
          [8.041313, -82.901826],
          [8.001949, -81.66458],
        ],
        5: [
          [7.93861, -78.401114],
          [8.785822, -78.441647],
          [9.076213, -78.036436],
          [8.775951, -77.695592],
          [8.623328, -77.913111],
          [8.070826, -77.547939],
          [8.161915, -77.260921],
          [7.933474, -77.167537],
          [7.522938, -77.568256],
          [7.704236, -77.71687],
          [8.102168, -78.172513],
          [7.704236, -77.71687],
          [7.450074, -77.723403],
          [7.483712, -77.812847],
          [7.245966, -77.894987],
          [7.93861, -78.401114],
        ],
        6: [
          [8.136543, -80.720596],
          [8.131105, -80.579147],
          [8.108673, -80.50705],
          [7.998533, -80.391007],
          [7.933251, -80.462418],
          [7.939372, -80.483704],
          [7.83708, -80.572696],
          [7.819347, -80.596369],
          [7.720097, -80.563464],
          [7.688332, -80.584244],
          [7.537986, -80.730581],
          [7.750297, -80.957499],
          [7.91475, -80.935269],
          [8.055841, -80.851979],
          [8.136543, -80.720596],
        ],
        7: [
          [7.997263, -80.368626],
          [7.482423, -79.974584],
          [7.237333, -80.613186],
          [7.517142, -80.7287],
          [7.662158, -80.621376],
          [7.679931, -80.583108],
          [7.83328, -80.573865],
          [7.939568, -80.47336],
          [7.997263, -80.368626],
        ],
        8: [
          [8.929528, -79.543634],
          [9.106622, -79.688422],
          [9.206351, -79.642472],
          [9.211808, -79.592038],
          [9.473242, -79.533535],
          [9.489519, -79.395859],
          [9.40716, -79.423625],
          [9.421877, -79.269418],
          [9.310786, -79.279811],
          [9.364643, -78.887416],
          [9.380003, -78.718095],
          [9.35373, -78.511429],
          [9.27235, -78.39065],
          [9.134791, -78.082987],
          [8.872478, -78.193203],
          [8.827381, -78.344204],
          [8.804276, -78.489431],
          [8.353733, -78.421656],
          [8.929528, -79.543634],
        ],
        9: [
          [8.780969, -81.214464],
          [8.882636, -80.874773],
          [8.749495, -80.737591],
          [8.56519, -80.780325],
          [8.563575, -80.828503],
          [8.13296, -80.704385],
          [7.860862, -80.957703],
          [7.242849, -80.623657],
          [7.213383, -80.886007],
          [7.986016, -81.672356],
          [8.4826, -81.338517],
          [8.435145, -81.120622],
          [8.780969, -81.214464],
        ],
        10: [
          [9.563604, -79.079616],
          [9.566313, -78.972499],
          [9.23613, -78.055222],
          [8.690411, -77.367122],
          [8.530189, -77.446773],
          [9.19913, -78.229549],
          [9.387512, -78.83105],
          [9.298755, -78.994472],
          [9.301465, -79.099529],
          [9.317728, -79.268444],
          [9.563604, -79.079616],
        ],
        11: [
          [8.626559, -77.895918],
          [8.774525, -77.72563],
          [8.72702, -77.628126],
          [8.521998, -77.449599],
          [8.473659, -77.407487],
          [8.203811, -77.271121],
          [8.082977, -77.581665],
          [8.264724, -77.72486],
          [8.626559, -77.895918],
        ],
        12: [
          [8.935302, -81.994299],
          [9.190553, -81.908933],
          [8.787988, -81.228555],
          [8.56538, -81.218162],
          [8.438421, -81.140511],
          [8.475043, -81.183383],
          [8.468156, -81.233396],
          [8.370461, -81.605008],
          [8.283234, -81.659856],
          [8.280576, -81.798627],
          [8.360305, -82.014394],
          [8.478982, -82.153165],
          [8.764227, -82.132868],
          [8.840316, -82.342368],
          [8.986664, -82.406399],
          [9.131704, -82.315237],
          [8.84657, -82.168365],
          [8.935302, -81.994299],
        ],
        13: [
          [8.410114, -80.041988],
          [8.898885, -80.166399],
          [8.957373, -80.137547],
          [9.177221, -79.920073],
          [9.107916, -79.698724],
          [8.92315, -79.567078],
          [8.65311, -79.6989],
          [8.410114, -80.041988],
        ],
        // Agregar los polígonos para otras provincias aquí
      }
      return provincias[idprovincia] || []
    },

    validateLatLong(value) {
      if (!value) {
        return true // Permitir que el campo esté vacío
      }
      try {
        // Verificar si value es una cadena
        if (typeof value !== 'string') {
          return 'El valor no es una cadena.'
        }

        // Dividir la entrada en líneas
        const lines = value.trim().split('\n')

        // Definir el patrón de regex para validar coordenadas decimales
        const decimalPattern = /^-?\d{1,3}\.\d+\s+-?\d{1,3}\.\d+$/

        // Recorrer cada línea para validar el formato
        for (let i = 0; i < lines.length; i++) {
          const line = lines[i].trim()

          // Verificar si la línea cumple con el patrón decimal
          if (!decimalPattern.test(line)) {
            // Intentar dividir por espacio para detectar latitud y longitud
            const parts = line.split(/\s+/)
            if (parts.length % 2 !== 0) {
              return `Formato inválido, ingresar latitud y despues longitud`
            }
            // Validar cada par de latitud y longitud
            for (let j = 0; j < parts.length; j += 2) {
              const latitude = parseFloat(parts[j])
              const longitude = parseFloat(parts[j + 1])
              if (
                isNaN(latitude) ||
                isNaN(longitude) ||
                latitude < -90 ||
                latitude > 90 ||
                longitude < -180 ||
                longitude > 180
              ) {
                return `Formato inválido, ingresar latitud y despues longitud`
              }
            }
          } else {
            // Si cumple el patrón directamente, validar el rango de latitud y longitud
            const [latitude, longitude] = line.split(/\s+/)
            if (
              parseFloat(latitude) < -90 ||
              parseFloat(latitude) > 90 ||
              parseFloat(longitude) < -180 ||
              parseFloat(longitude) > 180
            ) {
              return `Formato inválido, ingresar latitud y despues longitud`
            }
          }
        }
        // Si todas las líneas son válidas
        return true
      } catch (error) {
        console.error('Error en validateLatLong:', error)
        return 'Error al validar las coordenadas.'
      }
    },

    validateUTM(value) {
      const coordPairs = value.split(',').map((coord) => coord.trim())
      const utmRegex = /^\d{1,2}[C-HJ-NP-X]\s\d{6}\s\d{7}$/
      for (const pair of coordPairs) {
        if (!utmRegex.test(pair)) {
          return `Formato incorrecto: ${pair}. Debe ser zone easting northing en formato UTM.`
        }
        const [easting, northing] = pair.split(' ')
        if (parseInt(easting) < 100000 || parseInt(easting) > 999999) {
          return `Easting fuera de rango: ${easting}. Debe estar entre 100000 y 999999.`
        }
        if (parseInt(northing) < 0 || parseInt(northing) > 10000000) {
          return `Northing fuera de rango: ${northing}. Debe estar entre 0 y 10000000.`
        }
      }
      return true
    },

    updateLatLonString() {
      this.coordenadasString = this.coordenadas
        .map((coord) => `${coord.lat} ${coord.lon}`)
        .join(' ')
    },

    async updateUTMString() {
      const utmCoords = await Promise.all(
        this.coordenadas.map(async (coord) => {
          return await this.latLonToUTM(coord.lat, coord.lon)
        })
      )
      this.utmString = utmCoords.join(', ')
    },

    convertirAWKT(coordenadasString) {
      const coordsArray = coordenadasString.trim().split(' ')
      if (coordsArray.length < 2 || coordsArray.length % 2 !== 0) {
        return null
      }
      const lonLatPairs = []
      for (let i = 0; i < coordsArray.length; i += 2) {
        const lat = parseFloat(coordsArray[i])
        const lon = parseFloat(coordsArray[i + 1])
        if (!isNaN(lat) && !isNaN(lon)) {
          lonLatPairs.push(`${lon} ${lat}`)
        }
      }
      if (lonLatPairs.length === 1) {
        return `POINT(${lonLatPairs[0]})`
      } else {
        return `POLYGON((${lonLatPairs.join(', ')}))`
      }
    },

    convertirAWKTUTM(utmString) {
      const utmPairs = utmString.trim().split(',') // Dividir por comas
      const lonLatPairs = []
      for (let i = 0; i < utmPairs.length; i++) {
        const utmPair = utmPairs[i].trim().split(/\s+/) // Dividir por uno o más espacios
        const zoneNumber = parseInt(utmPair[0])
        const easting = parseFloat(utmPair[1])
        const northing = parseFloat(utmPair[2])

        if (!isNaN(zoneNumber) && !isNaN(easting) && !isNaN(northing)) {
          lonLatPairs.push(`${easting} ${northing}`)
        } else {
          console.error('Coordenadas UTM inválidas:', utmPairs[i])
          return null
        }
      }
      if (lonLatPairs.length === 1) {
        return `POINT(${lonLatPairs[0]})`
      } else if (lonLatPairs.length > 1) {
        // Cerramos el polígono volviendo al primer punto
        lonLatPairs.push(lonLatPairs[0])
        return `POLYGON((${lonLatPairs.join(', ')}))`
      } else {
        return null
      }
    },
    // genera un id si la finca no posee uno y registra la finca en el almacenamiento local
    async guardarYContinuar() {
      try {
        this.loading = true
        if (!this.$refs.form.validate()) {
          this.$store.commit('ui/setSnack', {
            text: 'Verifique los elementos en rojo',
            color: 'error',
          })
          return ''
        }
        if (await this.buscarRegistroExistente()) return

        if (!this.obtenerIdDeRuta()) {
          this.finca.id = uuid()
          this.finca.created_at = new Date().getTime() / 1000
        }
        this.finca.updated_at = new Date().getTime() / 1000

        // Validar y convertir coordenadas antes de guardar
        await this.validarCoordenadas()

        // Convertir coordenadas a WKT
        console.log('this.coordenadasString', this.coordenadasString)

        console.log('this.obtenerPosicionVar', this.obtenerPosicionVar)
        if (this.coordenadasString && this.obtenerPosicionVar === true) {
          const wkt = this.convertirAWKT(this.coordenadasString)
          if (wkt) {
            this.finca.latlong = wkt
          } else {
            this.$store.commit('ui/setSnack', {
              text: 'Formato de coordenadas incorrecto',
              color: 'error',
            })
            return
          }
        } else {
          // Si las coordenadas están vacías, eliminarlas de la parcela
          this.finca.latlong = this.latlongGPX
        }

        // Validar y convertir coordenadas antes de guardar
        await this.updateLatLonFromUTM()
        // Convertir coordenadas UTM a WKT
        if (this.utmString) {
          const wkt = this.convertirAWKTUTM(this.utmString)
          if (wkt) {
            this.finca.utm = wkt
          } else {
            this.$store.commit('ui/setSnack', {
              text: 'Formato de coordenadas UTM incorrecto',
              color: 'error',
            })
            return
          }
        } else {
          // Si las coordenadas UTM están vacías, eliminarlas de la parcela
          this.finca.utm = null
        }

        this.$store.dispatch('registros/guardarFinca', clona(this.finca))
        this.$router.push('/ru/fincasb')
      } catch (error) {
        this.$sentry.captureException(error)
      } finally {
        this.loading = false
      }
    },
    // Función para extraer y formatear coordenadas de WKT
    extractAndFormatCoordinates() {
      if (this.coordenadasString.startsWith('POLYGON')) {
        const coords = this.coordenadasString.match(/\(([^())]+)\)/)[1].trim()
        const coordPairs = coords
          .split(',')
          .map((pair) => pair.trim().split(' ').reverse().join(' '))
          .join(' ')
        this.coordenadasString = coordPairs
      } else if (this.coordenadasString.startsWith('POINT')) {
        const coords = this.coordenadasString
          .match(/\(([^())]+)\)/)[1]
          .trim()
          .split(' ')
          .reverse()
          .join(' ')
        this.coordenadasString = coords
      }
    },
    async cargarRegistroExistente() {
      const id = this.registro_existente.id
      this.modal_registro_existe_loading = true
      if (!this.existeRegistroEnState('fincas', id)) {
        await this.cargarRegistroDelServer(this.registro_existente)
      }
      this.$router.push(`/ru/finca/${id}`)
      this.cerrarModalRegistroExistente()
      this.modal_registro_existe_loading = false
    },
    cargarRegistro(id) {
      this.existing_finca = clona(existing_finca)
      if (this.existeRegistroEnState('fincas', id)) {
        this.finca = this.obtenerRegistroDelState(id)
        this.coordenadasString = this.finca.latlong || '' // Actualiza con las coordenadas almacenadas en la base de datos
        this.extractAndFormatCoordinates()
        this.updateUTMFromLatLon() // Convierte coordenadas a UTM y actualiza utmString
        this.$refs.form.resetValidation()
        this.obtenerFincasPorRegistro()
        return true
      } else return false
    },
    async buscarRegistroExistente() {
      const registro = await this.obtenerUnRegistroONada()
      if (elObjetoTienePropiedades(registro)) {
        const id = registro.id ? registro.id.toString() : ''
        if (id === this.obtenerIdDeRuta()) return false
        this.almacenarRegistroEncontradoTemporalmente(registro)
        this.mostrarModalDeRegistroExistente()
        return true
      }
      return false
    },
    debounceBuscarRegistroExistente: debounce(async function () {
      await this.buscarRegistroExistente()
    }, 1500),

    debounceBuscarRegistroExistenteRuc: debounce(async function () {
      await this.buscarRegistroExistenteRuc()
    }, 1500),
    //SOLO para Validar la existencia del RUC en el Server
    async buscarRegistroExistenteRuc() {
      //lista 1 RUC del server por la variable ruc enviada
      const registro = await this.obtenerEmpresasPorRegistro()
      if (elObjetoTienePropiedades(registro)) {
        const ruc = registro.ruc ? registro.ruc.toString() : ''
        //if (id === this.obtenerIdDeRuta()) {
        if (ruc === this.finca.ruc) {
          return true
        }
        this.mostrarModalDeRegistroExistenteRuc()
        return false
      } else {
        this.mostrarModalDeRegistroExistenteRuc()
        return false
      }
    },
    //obtiene un RUC existente
    async obtenerEmpresasPorRegistro() {
      try {
        this.existing_empresa = clona(existing_empresa)
        const ruc = this.finca.ruc
        // required fields to be fulfilled
        if (ruc) {
          const { status, data } = await this.$store.dispatch(
            'registros/listarEmpresas',
            { ruc }
          )
          if (status === 'ok' && data.length > 0) {
            if (data[0].ruc !== this.finca.ruc) {
              this.existing_empresa = clona({
                ruc: this.finca.ruc,
              })
            } else {
              this.finca.ruc = data[0].ruc
              return data[0]
            }
          }
        }
        return {}
      } catch (error) {
        this.$sentry.captureException(error)
      }
    },
    mostrarModalDeRegistroExistenteRuc() {
      this.modal_registro_existe_Ruc = true
    },
    cerrarModalDeRegistroExistenteRuc() {
      this.modal_registro_existe_Ruc = false
    },
    async obtenerUnRegistroONada() {
      try {
        const num_registro = this.finca.num_registro
        const nombre = this.finca.nombre
        const id_productor = this.finca.id_productor
        // required fields to be fulfilled
        if (nombre && id_productor) {
          const fincas = this.getMatchingRecords({
            recordName: 'fincas',
            matchValues: [
              { key: 'num_registro', value: num_registro },
              { key: 'nombre', value: nombre },
              { key: 'id_productor', value: id_productor },
            ],
          })
          if (fincas.length > 0) return fincas[0]

          const { status, data } = await this.$store.dispatch(
            'registros/listarFincas',
            {
              num_registro,
              nombre,
              id_productor,
            }
          )
          if (status === 'ok' && data.length > 0) return data[0]
        }
        return {}
      } catch (e) {
        return {}
      }
    },
    async obtenerFincasPorRegistro() {
      try {
        this.existing_finca = clona(existing_finca)
        const num_registro = this.finca.num_registro
        const nombre = ''
        const id_productor = ''
        // required fields to be fulfilled
        if (num_registro) {
          const { status, data } = await this.$store.dispatch(
            'registros/listarFincas',
            {
              num_registro,
              nombre,
              id_productor,
            }
          )
          if (status === 'ok' && data.length > 0) {
            if (data[0].id !== this.finca.id) {
              this.existing_finca = clona({
                id_productor: this.finca.id_productor,
                nombre: data[0].nombre,
                num_registro: data[0].num_registro,
              })
              this.finca.id_finca = data[0].id_finca
              this.finca.nombre = data[0].nombre
              this.name_exists = false
            }
          }
        }
        await this.obtenerFincasPorNombre()
        return {}
      } catch (error) {
        this.$sentry.captureException(error)
      }
    },
    debounceObtenerFincasPorRegistro: debounce(async function () {
      await this.obtenerFincasPorRegistro()
    }, 1500),
    async obtenerFincasPorNombre() {
      try {
        this.name_exists = false
        const num_registro = ''
        const nombre = this.finca.nombre
        const id_productor = ''
        //  fields to be fulfilled
        if (nombre) {
          const { status, data } = await this.$store.dispatch(
            'registros/listarFincas',
            {
              num_registro,
              nombre,
              id_productor,
            }
          )
          if (status === 'ok' && data.length > 0) {
            if (!this.existing_finca.nombre && this.finca.id !== data[0].id) {
              this.name_exists = true
            }
          }
        }
        return {}
      } catch (e) {
        console.error(e)
        return {}
      }
    },
    debounceObtenerFincasPorNombre: debounce(async function () {
      await this.obtenerFincasPorNombre()
    }, 1500),
    async cargarRegistroDelServer(registro) {
      try {
        await this.$store.dispatch('registros/getFinca', registro)
        return true
      } catch (e) {
        return false
      }
    },
    mostrarModalDeRegistroExistente() {
      this.modal_registro_existe = true
    },
    cerrarModalRegistroExistente() {
      this.modal_registro_existe = false
    },
    almacenarRegistroEncontradoTemporalmente(registro) {
      this.registro_existente = registro
    },
    obtenerRegistroDelState(id) {
      return {
        ...formulario_de_finca,
        ...this.$store.state.registros.fincas[id],
      }
    },
    obtenerIdDeRuta() {
      return this.$route.params.id || ''
    },
  },
}
</script>

<style scoped>
#mapita {
  height: 300px;
  width: 100%;
  z-index: 0;
  margin-top: 0px;
}

.custom-row {
  display: flex;
  align-items: center;
}

.btn-oval {
  border-radius: 50px; /* Hace que el botón sea más ovalado */
}
.btn-final {
  display: flex;
}
.cancel {
  background-color: red !important;
  color: white !important;
}
</style>
